<template lang="pug">
.offers-page
  Breadcrumbs(:list="breadcrumbs")

  h1.offers-page__h1 {{ pageH1 }}

  .offers-page__header
    .offers-page__header-text-container
      span.offers-page__header-text(v-t="'offersPageHeaderText'")
      a.offers-page__header-create-offer(:href="$i18n.locale === 'ru' ? 'https://docs.google.com/forms/d/e/1FAIpQLSe3SpTTwKRA1YT9LdYN3jXNRLNX3qK7ZPrtcrQbybK4W-AhCg/viewform?usp=send_form' : 'https://docs.google.com/forms/d/e/1FAIpQLSeicYshdkTfeBKs78MG5KtaNHdaPL2qHK24ftbmAqi4vxrlkw/viewform?usp=send_form'" target="_blank") +&nbsp;&nbsp;{{ $t('createOffer') }}
    a.offers-page__header-telegram-button(href="https://t.me/offers_gaming_goods")
      Button.offers-page__header-telegram-button(is-primary)
        img.offers-page__header-telegram-button-icon(src="https://cdn.gaming-goods.com/images/missions/telegram.webp" width="20" alt="telegram")
        | Telegram

  .offers-page__filters-top
    .offers-page__filters-top-block
      .offers-page__filters-top-block-element
        .offers-page__filters-top-block-element-label(v-t="'OS'")
        .offers-page__filters-top-block-element-input
          span {{ realDevice }}
      .offers-page__filters-top-block-element(v-if="countryCode")
        .offers-page__filters-top-block-element-label(v-t="'geoRegion'")
        .offers-page__filters-top-block-element-input
          span {{ realCountry }}

  .offers-page__slider--violet(v-if="bestOffersListLength")
    .offers-page__filters-top-title-container
      p.offers-page__filters-top-title(v-t="'bestOffers'")
      NuxtLink(:to="localeLocation('/missions/best')")
        Button.offers-page__filters-top-title-button(is-primary icon="arrow-right")
          | {{ $t('showAll') }} ({{ bestOffersCount }})
    .offers-page__slider(:style="{'--amount': bestOffersListLength}")
      .offers-page__offers-offer(v-for='offer in bestOffersList' :key='`best_${offer.id}`')
        img.offers-page__offers-offer-img(:src='offer.cover' alt='cover')
        .offers-page__offers-offer-body
          .offers-page__offers-offer-body-name {{ offer.name }}
          .offers-page__offers-offer-body-category-label(v-t='"category"')
          .offers-page__offers-offer-body-category-name(v-t='offerCategory(offer)')
        .offers-page__offers-offer-payout
          span.offers-page__offers-offer-payout-amount +{{ offerPayout(offer) }}
          span.offers-page__offers-offer-payout-currency €
        Button.offers-page__offers-offer-button(is-primary @click="openOffer(offer)") {{ $t('start') }}

  template(v-if="featuredOffersListLength")
    .offers-page__filters-top-title(v-t="'popularOffers'")
    .offers-page__slider(:style="{'--amount': featuredOffersListLength}")
      .offers-page__offers-offer(v-for='offer in featuredOffersList' :key='`featured_${offer.id}`')
        img.offers-page__offers-offer-img(:src='offer.cover' alt='cover')
        .offers-page__offers-offer-body
          .offers-page__offers-offer-body-name {{ offer.name }}
          .offers-page__offers-offer-body-category-label(v-t='"category"')
          .offers-page__offers-offer-body-category-name(v-t='offerCategory(offer)')
        .offers-page__offers-offer-payout
          span.offers-page__offers-offer-payout-amount +{{ offerPayout(offer) }}
          span.offers-page__offers-offer-payout-currency €
        Button.offers-page__offers-offer-button(is-primary @click="openOffer(offer)") {{ $t('start') }}

  .offers-page__filters-top
    template(v-if="!isRu")
      .offers-page__filters-top-title(v-t="'offerwalls'")
      .offers-page__offerwalls(:style="{'--count': Math.ceil((missionsGroups.length || 0) / 2)}")
        .offers-page__offerwalls-offerwall(v-for="offerwall in missionsGroups" :key="offerwall.id" @click="openOfferwall(offerwall)")
          img.offers-page__offerwalls-offerwall-icon(:src="offerwall.icon" :alt="offerwall.title")

    .offers-page__filters-top-with-search
      .offers-page__filters-top-title(v-t="offersTitle")
      .offers-page__filters-top-search
        FormInput(
          icon="search"
          :placeholder="$t('search')"
          v-model="searchText"
          @iconClick="loadOffers"
          @keyup.enter.native="loadOffers"
        )

    .offers-page__filters-bottom
      BaseSelect(
        :options="devices"
        :value="device"
        :with-empty-value="true"
        :placeholder="$t('deviceType')"
        @input="onDeviceChange($event)"
      )
        span {{ device }}
      template(v-if="countryCode")
        BaseSelect(
          :options="countries"
          :value="countryCode"
          :with-empty-value="false"
          @input="onCountryChange($event)"
        )
          span {{ country }}
      BaseSelect(
        :options="categoriesOptions"
        :value="category"
        :with-empty-value="true"
        :placeholder="$t('allOffers')"
        @input="onCategoryChange($event)"
      )
        span {{ categoryName }}
      BaseSelect(
        :options="offerwallsOptions"
        :value="offerwallName"
        :with-empty-value="true"
        :placeholder="$t('allOfferwalls')"
        @input="onSourceChange($event)"
      )
        span {{ categoryName }}
      BaseSelect(
        :options="sortOptions"
        :value="sortKey"
        :with-empty-value="true"
        :placeholder="$t('sort')"
        @input="onSortChange($event)"
      )
        span {{ country }}

  .offers-page__offers(v-if='offers')
    .offers-page__offers-list
      .offers-page__offers-offer(v-for='offer in offers' :key='offer.id')
        img.offers-page__offers-offer-img(:src='offer.cover' alt='cover')
        .offers-page__offers-offer-body
          .offers-page__offers-offer-body-name {{ offer.name }}
          .offers-page__offers-offer-body-category-label(v-t='"category"')
          .offers-page__offers-offer-body-category-name(v-t='offerCategory(offer)')
        .offers-page__offers-offer-payout
          span.offers-page__offers-offer-payout-amount +{{ offerPayout(offer) }}
          span.offers-page__offers-offer-payout-currency €
        Button.offers-page__offers-offer-button(is-primary @click="openOffer(offer)") {{ $t('start') }}
  Pagination(
    v-if="offers && offers.length"
    :per-page="pageSize"
    :pages-count="offersPagesCount"
    :current-page="page - 1"
    @perPageChange="onOffersPerPageChange"
    @pageChange="onOffersPageChange")

  PageArticle(v-if="article" :content="article")
</template>

<script>
import OfferwallService from '@/services/OfferwallService'
import { mapActions, mapGetters, mapState } from 'vuex'
import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs'
import BaseSelect from '~/components/BaseSelect/BaseSelect'
import FormInput from '~/components/FormInput'
import Pagination from '~/components/Pagination/Pagination'
import PageArticle from '~/components/MarketplaceComponents/PageArticle'
import { countryByCode, allCountries } from '~/utils/country'
import { getDeviceTypeForOffers } from '~/utils/get-device-type'
import { createMeta } from '~/utils/meta'

export default {
  components: { Breadcrumbs, BaseSelect, FormInput, Pagination, PageArticle },

  data () {
    return {
      offersCount: 0,
      offersType: '',
      searchText: '',
      offerwallName: '',
      offerwallsOptions: [
        {
          value: 'AyetStudios',
          title: 'AyetStudios'
        },
        // {
        //   value: 'AdToGame',
        //   title: 'AdToGame'
        // },
        {
          value: 'AdGateMedia',
          title: 'AdGateMedia'
        },
        {
          value: 'Lootably',
          title: 'Lootably'
        },
        {
          value: 'Offer Toro',
          title: 'Offer Toro'
        },
        {
          value: 'Notik',
          title: 'Notik'
        },
        {
          value: 'OVO',
          title: 'OVO'
        },
        {
          value: 'Farly',
          title: 'Farly'
        }
      ],
      devices: [
        {
          value: 'android',
          title: 'Android'
        },
        {
          value: 'ios',
          title: 'iOS'
        },
        {
          value: 'windows',
          title: 'Windows'
        },
        {
          value: 'mac',
          title: 'Apple'
        }
      ],
      device: '',
      sortKey: 'payout desc',
      realDevice: undefined,
      realCountryCode: undefined,
      category: '',
      page: 1,
      pageSize: 12,
      offers: undefined,
      featuredOffers: undefined,
      bestOffers: undefined,
      bestOffersCount: undefined,
      countryCode: undefined
    }
  },

  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['isAdmin']),

    isRu () {
      return this.$i18n.locale === 'ru'
    },

    article () {
      if (this.$i18n.locale.includes('en')) {
        return '<h2>Maximize Your Earnings with Offerwalls on gaming-goods.com</h2> <p>We welcome you on <b>gaming-goods.com!</b> In today’s digital age, finding ways to earn money online is easier than ever. Platforms like <b>gaming-goods.com</b> have revolutionized the way users can monetize their time by completing various online tasks. Offerwalls are a fantastic way to earn rewards and real money by engaging in simple activities from the comfort of your home or on the go. This article will guide you through the process of making the most out of offerwalls and the rewarding offers available on <b>gaming-goods.com</b>.</p> <h3>Why Choose gaming-goods.com for Offerwalls?</h3> <h4>Trusted and Verified Platform</h4> <p>One of the key advantages of using gaming-goods.com is the platform\'s reliability and trustworthiness. It has been verified by numerous users worldwide, exists for many years, making it a popular choice for those looking to earn money online through offerwalls. You can be assured that the tasks are legitimate and that the platform offers real payouts.</p> <h4>Diverse Range of Tasks</h4> <p>gaming-goods.com offers a variety of tasks that cater to different interests and skill levels. Whether you\'re using a <b>computer, PC, laptop, or smartphone (Android/iOS)</b>, there are tasks that you can easily complete. These tasks range from <b>quizzes and surveys to installations, registrations, and even pay-per-click activities</b>. This diversity ensures that there\'s something for everyone, making it easier to earn consistently.</p> <h4>Daily Rewards and Bonuses</h4> <p>The platform offers daily rewards and bonuses, encouraging users to stay active and complete tasks regularly. By logging in daily and completing the task list, you can maximize your earnings and take advantage of special bonuses and promotions.</p> <h4>No Investment Required</h4> <p>One of the most appealing aspects of gaming-goods.com is that you can start earning without any initial investment. There are no fees to join, and you can begin completing tasks and earning rewards immediately. This makes it an excellent option for those looking to make some extra money without any financial risk.</p> <h3>How to Start Earning with Offerwalls</h3> <h4>Step 1: Register on gaming-goods.com</h4> <p>The first step is to create an account on gaming-goods.com. The registration process is straightforward and free. Simply provide your details, and you’re ready to start.</p> <h4>Step 2: Explore Offerwalls</h4> <p>Once registered, navigate to the offerwalls section of the website. Here, you\'ll find various offerwalls from partners like <b>AyetStudios, AdGateMedia, Lootably, Offer Toro, Notik, OVO, and Farly</b>. These offerwalls list numerous tasks you can complete to earn rewards.</p> <h4>Step 3: Choose and Complete Tasks</h4> <p>Browse through the available tasks and choose the ones that interest you. Tasks can include:</p> <p><ul><li> <b>Surveys</b>: Share your opinion on various topics.</li> <li> <b>Quizzes</b>: Answer questions and test your knowledge.</li> <li> <b>Installations</b>: Download and install apps on your device.</li> <li> <b>Registrations</b>: Sign up for websites or services.</li> <li> <b>Pay-per-click</b>: Click on ads and explore websites.</li> <li> <b>Giveaways and Deposits</b>: Participate in contests or make small deposits in partnered platforms like online casinos for cashback.</li> <p>Each task will specify the reward and the requirements for completion. Follow the instructions carefully to ensure you receive your earnings.</p> <h4>Step 4: Withdraw Your Earnings</h4> <p>After completing tasks and accumulating rewards, you can withdraw your earnings. gaming-goods.com offers various withdrawal options, including <b>euro withdrawals</b>. Ensure you meet the minimum withdrawal threshold and select your preferred withdrawal method to receive your money.</p> <h3>Tips to Maximize Your Earnings</h3> <h4>1. Complete High-Paying Tasks</h4> <p>Focus on tasks that offer higher rewards. While some tasks may take a bit longer, the higher payout will make it worthwhile.</p> <h4>2. Daily Activity</h4> <p>Log in daily to take advantage of the daily rewards and bonuses. Completing tasks regularly helps you accumulate more earnings over time.</p> <h4>3. Use Multiple Devices</h4> <p>Since gaming-goods.com supports <b>Windows, Android, and iOS</b>, you can complete tasks on multiple devices. This flexibility allows you to earn even when you’re away from your computer.</p> <h4>4. Refer Friends</h4> <p>Many offerwalls have referral programs where you can earn additional rewards by inviting friends to join. Share your referral link and earn a percentage of your friends’ earnings.</p> <h4>5. Stay Updated</h4> <p>Keep an eye on the latest updates and promotions on the platform. New tasks and special offers are added regularly, giving you more opportunities to earn.</p> <h3>Common Tasks on Offerwalls</h3> <h4>Surveys and Quizzes</h4> <p>Surveys and quizzes are among the most popular tasks on offerwalls. They are easy to complete and don’t require any special skills. Simply provide your opinion or answer questions to earn rewards.</p> <h4>App Installations</h4> <p>Earn money by installing and trying out new apps. This is a straightforward way to earn, especially if you enjoy discovering new software and games.</p> <h4>Website Registrations</h4> <p>Signing up for new services or websites is another common task. Ensure you follow the registration process correctly to receive your reward.</p> <h4>Pay-per-Click</h4> <p>Click on advertisements and explore the advertised websites. This task is usually quick and easy, providing a simple way to earn.</p> <h4>Giveaways and Deposits</h4> <p>Participate in giveaways or make small deposits in online casinos to earn cashback. This can be a fun way to earn rewards, especially if you enjoy online gaming.</p> <h3>Why Offerwalls are a Great Way to Earn Money Online</h3> <h4>Flexibility</h4> <p>Offerwalls provide the flexibility to work at your own pace and from any location. Whether you have a few minutes or a few hours, you can find tasks that fit your schedule.</p> <h4>No Experience Required</h4> <p>You don’t need any prior experience to start earning with offerwalls. The tasks are simple and easy to understand, making them accessible to everyone.</p> <h4>Multiple Earning Opportunities</h4> <p>With a variety of tasks available, you can choose the ones that you enjoy the most. This variety keeps the process interesting and increases your earning potential.</p> <h4>Legitimate Earnings</h4> <p>Platforms like <b>gaming-goods.com</b> ensure that the tasks are legitimate and the rewards are real. You can trust that your time and effort will be compensated.</p> <h3>Conclusion</h3> <p>Offerwalls on <b>gaming-goods.com</b> provide a fantastic opportunity to earn money online by completing simple tasks. Whether you’re looking for a part-time job online, a way to earn extra cash, or just a fun way to spend your free time, offerwalls are an excellent choice. With a wide range of tasks, daily rewards, and no investment required, you can start earning right away. Register on gaming-goods.com today, explore the offerwalls, and begin your journey to earning real money online.</p>'
      }

      return undefined
    },

    breadcrumbs () {
      return [
        { title: this.$t('quests'), to: '/missions' },
        { title: this.$t(this.offersTitle) }
      ]
    },

    pageH1 () {
      let h1 = this.$t('menuQuests')

      if (this.$i18n.locale.includes('en')) {
        switch (this.$route.query.lang) {
          case 'KZ':
            h1 = 'Интернетте табыс табуға арналған ең үздік офферволлдар'
            break
          case 'DE':
            h1 = 'Die besten Offerwalls, um in Deutschland online Geld zu verdienen'
            break
          case 'CY':
            h1 = 'Κορυφαίες Offerwalls για να Βγάλετε Χρήματα Online στην Κύπρο'
            break
          case 'GR':
            h1 = 'Κορυφαίες Offerwalls για να Βγάλετε Χρήματα Online στην Ελλάδα'
            break
          case 'PL':
            h1 = 'Najlepsze Offerwalle do Zarabiania Online w Polsce'
            break
          case 'PT':
            h1 = 'As Melhores Offerwalls para Ganhar Dinheiro Online em Portugal'
            break
          case 'TR':
            h1 = 'Türkiye’de Online Para Kazandıran En İyi Offerwalls'
            break
          case 'TH':
            h1 = 'Best Offerwalls to Make Money Online'
            break
          case 'ES':
            h1 = 'Las mejores Offerwalls para ganar dinero online'
            break
          case 'FR':
            h1 = 'Les meilleures offerwalls pour gagner de l’argent en ligne'
            break
          case 'AT':
            h1 = 'Die besten Offerwalls, um in Österreich online Geld zu verdienen'
            break
          case 'BE':
            h1 = 'Les meilleures offerwalls pour gagner de l’argent en ligne'
            break
          case 'BR':
            h1 = 'As Melhores Offerwalls para Ganhar Dinheiro Online'
            break
          case 'CA':
            h1 = 'Best Offerwalls for Earning Money Online'
            break
          case 'CL':
            h1 = 'Las mejores offerwalls para ganar dinero en línea'
            break
          case 'JP':
            h1 = '日本でオンライン収入を得るためのベスト・オファーウォール'
            break
          case 'KR':
            h1 = '한국에서 온라인으로 돈을 벌 수 있는 최고의 오퍼월(Offerwall)'
            break
          case 'MX':
            h1 = 'Las mejores offerwalls para ganar dinero en línea'
            break
          case 'RO':
            h1 = 'Cele mai bune offerwalls pentru a câștiga bani online'
            break
          case 'SG':
            h1 = 'Best Offerwalls for Earning Money Online'
            break
          case 'VN':
            h1 = 'Những offerwall tốt nhất để kiếm tiền trực tuyến tại Việt Nam'
            break
          case 'LV':
            h1 = 'Labākās Offerwalls, lai nopelnītu naudu tiešsaistē Latvijā'
            break
          case 'LT':
            h1 = 'Geriausios Offerwalls, padedančios uždirbti pinigų internete Lietuvoje'
            break
          case 'IT':
            h1 = 'Le migliori offerwall per guadagnare denaro online'
            break
          case 'ID':
            h1 = 'Offerwall Terbaik untuk Menghasilkan Uang Secara Online'
            break
          case 'AU':
            h1 = 'Best Offerwalls for Earning Money Online'
            break
          case 'CZ':
            h1 = 'Nejlepší Offerwalls pro vydělávání peněz online'
            break
          case 'FI':
            h1 = 'Parhaat Offerwallit rahan ansaitsemiseen verkossa'
            break
          case 'EE':
            h1 = 'Parimad Offerwallid, et Eestis internetis raha teenida'
            break
          case 'NL':
            h1 = 'De beste offerwalls om online geld te verdienen'
            break
          case 'SE':
            h1 = 'De bästa Offerwalls för att tjäna pengar online'
            break
        }
      }

      return h1
    },

    offersPagesCount () {
      console.log(this.offersCount, this.pageSize)
      return Math.ceil(this.offersCount / this.pageSize)
    },

    missionsGroups () {
      return [
        // OfferwallService.getOfferwallGroup(this.$axios, this.user?.id, undefined, this.isAdmin).find(item => item.name === 'vvv'),
        ...OfferwallService.getOfferwallGroup(this.$axios, this.user?.id, undefined, this.isAdmin).filter(item => item.name !== 'vvv')
      ]
    },

    sortOptions () {
      return [
        {
          value: 'popularity desc',
          title: this.$t('byPopularity')
        },
        {
          value: 'payout desc',
          title: this.$t('byRewardSizeZA')
        },
        {
          value: 'payout asc',
          title: this.$t('byRewardSizeAZ')
        }
      ]
    },

    categoriesOptions () {
      return [
        {
          value: 'offer_type_pay_per_click',
          title: this.$t('offer_type_pay_per_click')
        },
        {
          value: 'offer_type_app_downloads',
          title: this.$t('offer_type_app_downloads')
        },
        {
          value: 'offer_type_games',
          title: this.$t('offer_type_games')
        },
        {
          value: 'offer_type_surveys',
          title: this.$t('offer_type_surveys')
        },
        {
          value: 'offer_type_quizzes',
          title: this.$t('offer_type_quizzes')
        },
        {
          value: 'offer_type_sweeps',
          title: this.$t('offer_type_sweeps')
        },
        {
          value: 'offer_type_deposits',
          title: this.$t('offer_type_deposits')
        },
        {
          value: 'offer_type_purchases',
          title: this.$t('offer_type_purchases')
        },
        {
          value: 'offer_type_subscriptions',
          title: this.$t('offer_type_subscriptions')
        },
        {
          value: 'offer_type_cryptocurrencies',
          title: this.$t('offer_type_cryptocurrencies')
        }
      ]
    },

    offersTitle () {
      if (this.offersType === '') {
        return 'allOffers'
      }
      return this.offersType
    },

    country () {
      return countryByCode(this.countryCode)
    },

    categoryName () {
      return this.categoriesOptions.find(option => option.value === this.category)?.title
    },

    realCountry () {
      return countryByCode(this.realCountryCode)
    },

    countries () {
      return allCountries(true)
    },

    featuredOffersList () {
      return this.featuredOffers?.slice(0, 4)
    },

    featuredOffersListLength () {
      return this.featuredOffersList?.length || 0
    },

    bestOffersList () {
      return this.bestOffers?.slice(0, 20)
    },

    bestOffersListLength () {
      return this.bestOffers?.length || 0
    }
  },

  async mounted () {
    await this.loadCountry()
    this.loadDevice()
    await this.loadFeaturedOffers()
    await this.loadBestOffers()
    this.loadOffers()
    try {
      if (this.$route.query.offer_id) {
        const offer = await this.loadOneOffer(this.$route.query.offer_id)
        if (offer) {
          this.openOffer(offer)
        }
      }
    } catch (e) {
      console.log(e)
    }
  },

  methods: {
    ...mapActions('modal', ['showModal']),

    openOffer (offer) {
      this.showModal({
        component: 'ModalOfferDetails',
        data: {
          offer,
          startCountryCode: this.realCountryCode
        }
      })
    },

    openOfferwall (offerwall) {
      this.$router.push(this.localeLocation(`/missions/${offerwall?.name}`))
    },

    onOffersPerPageChange (value) {
      this.pageSize = value
      this.page = 1
      this.$nuxt.$loading.start()
      this.loadOffers()
      this.$nuxt.$loading.finish()
    },

    onOffersPageChange (value) {
      this.page = value + 1
      this.$nuxt.$loading.start()
      this.loadOffers()
      this.$nuxt.$loading.finish()
    },

    async loadFeaturedOffers () {
      try {
        this.featuredOffers = await OfferwallService.loadFeaturedOffers(this.$axios, this.realCountryCode, this.realDevice)
      } catch (e) {
        console.log(e)
      }
    },

    async loadBestOffers () {
      try {
        const result = await OfferwallService.loadBestOffers(this.$axios, this.realCountryCode, this.realDevice)
        this.bestOffers = result.offers
        this.bestOffersCount = result.count?.[0]?.count
      } catch (e) {
        console.log(e)
      }
    },

    async loadOneOffer (id) {
      return await OfferwallService.loadOneOffer(this.$axios, id)
    },

    async loadOffers () {
      this.offers = undefined
      this.$nuxt.$loading.start()
      try {
        const { offers, count } = await OfferwallService.loadOffers(this.$axios, this.page, this.pageSize, this.countryCode, this.device, this.category, this.sortKey, this.searchText, this.offerwallName)
        this.offers = offers
        console.log('count:', count)
        this.offersCount = +count?.[0].count
      } catch (e) {
        console.log(e)
      }
      this.$nuxt.$loading.finish()
    },

    async loadCountry () {
      this.realCountryCode = await OfferwallService.getCountry(this.$axios)
      this.countryCode = this.$route.query.lang || this.realCountryCode
    },

    loadDevice () {
      this.device = getDeviceTypeForOffers()
      this.realDevice = this.device
    },

    offerCategory (offer) {
      if (this.category === '') {
        return offer?.categories?.[offer?.categories.length - 1]
      } else {
        return this.$t(this.categoriesOptions.find(option => option.value === this.category)?.value)
      }
    },

    offerPayout (offer) {
      return offer.payout.toFixed(2).replace('.00', '')
    },

    onCountryChange (event) {
      this.countryCode = event
      this.$router.push(this.localeLocation(`/missions?lang=${this.countryCode}`))
      this.loadOffers()
    },

    onDeviceChange (event) {
      this.device = event
      this.loadOffers()
    },

    onCategoryChange (event) {
      this.category = event
      this.loadOffers()
    },

    onSourceChange (event) {
      this.offerwallName = event
      this.loadOffers()
    },

    onSortChange (event) {
      this.sortKey = event
      this.loadOffers()
    },

    onChangeSearchText (event) {
      this.searchText = event
    }
  },

  head () {
    if (this.$i18n.locale.includes('en')) {
      let title = ''
      let description = ''
      switch (this.$route.query.lang) {
        case 'KZ':
          title = 'Интернеттегі табыс: Қазақстандағы ақылы сауалнамалар, сыйақы сайттары және ақша үшін ойындар'
          description = 'Қазақстанда интернет арқылы нақты ақша табыңыз: үздік ақылы сауалнамаларға қатысып, ақша үшін ойындар ойнаңыз және сыйақы сайттарынан табыс жинаңыз. Ыңғайлы мобильді қосымшалармен ақшаны тез алыңыз, қаражатты банк картаңызға лезде шығарыңыз. Интернеттегі табыс сізге қолжетімді!'
          break
        case 'DE':
          title = 'Online-Einkommen: Bezahlte Umfragen, Belohnungsseiten und Geldspiele'
          description = 'Verdienen Sie echtes Geld im Internet: Nehmen Sie an hochbezahlten Umfragen in Deutschland teil, spielen Sie lukrative Geldspiele und nutzen Sie die besten Belohnungsseiten, um ein stabiles Online-Einkommen aufzubauen. Profitieren Sie von praktischen Apps, um Ihre Auszahlungen schnell auf Ihr Konto oder Ihre Karte zu erhalten. Online-Geld verdienen war noch nie so einfach!'
          break
        case 'CY':
          title = 'Κερδίστε Χρήματα Online: Επί Πληρωμή Έρευνες στην Κύπρο, Σελίδες Ανταμοιβών και Παιχνίδια με Χρηματικά Έπαθλα'
          description = 'Αποκτήστε αληθινά χρήματα μέσω διαδικτύου: Συμμετάσχετε σε επί πληρωμή έρευνες υψηλής αμοιβής στην Κύπρο, αξιοποιήστε τις καλύτερες σελίδες ανταμοιβών και παίξτε παιχνίδια με χρηματικά έπαθλα. Χρησιμοποιήστε εύχρηστες εφαρμογές για γρήγορες αναλήψεις στην κάρτα ή τον λογαριασμό σας.'
          break
        case 'GR':
          title = 'Κερδίστε Χρήματα Online: Επί Πληρωμή Έρευνες στην Ελλάδα, Σελίδες Ανταμοιβών και Παιχνίδια με Χρηματικά Έπαθλα'
          description = 'Αποκτήστε αληθινά χρήματα μέσω διαδικτύου: Συμμετάσχετε σε επί πληρωμή έρευνες υψηλής αμοιβής στην Ελλάδα, αξιοποιήστε τις καλύτερες σελίδες ανταμοιβών και παίξτε παιχνίδια με χρηματικά έπαθλα. Χρησιμοποιήστε εύχρηστες εφαρμογές για γρήγορες αναλήψεις στην κάρτα ή τον λογαριασμό σας.'
          break
        case 'PL':
          title = 'Zarabiaj Online: Płatne Ankiety w Polsce, Strony z Nagrodami i Gry za Pieniądze'
          description = 'Zdobądź prawdziwe pieniądze przez internet: Weź udział w wysoko płatnych ankietach w Polsce, skorzystaj z najlepszych stron z nagrodami i graj w gry, które przynoszą realne zyski. Dzięki wygodnym aplikacjom szybko wypłacisz środki na swoje konto lub kartę.'
          break
        case 'PT':
          title = 'Ganhe Dinheiro Online: Inquéritos Pagos, Sites de Recompensas e Jogos a Dinheiro'
          description = 'Obtenha dinheiro real através da internet: participe em inquéritos bem remunerados, aproveite os melhores sites de recompensas e jogue jogos que oferecem ganhos reais. Com aplicações práticas, pode levantar rapidamente os seus fundos para o seu cartão ou conta bancária.'
          break
        case 'TR':
          title = 'İnternetten Para Kazanın: Türkiye’de Ücretli Anketler, Ödül Siteleri ve Gerçek Para Veren Oyunlar'
          description = 'Türkiye’de internet üzerinden gerçek para kazanın: Yüksek ücretli anketlere katılın, en iyi ödül sitelerini kullanın ve gerçek para kazandıran oyunlar oynayın. Pratik uygulamalarla kazancınızı hızlıca kartınıza veya hesabınıza aktarın.'
          break
        case 'TH':
          title = 'สร้างรายได้ออนไลน์: แบบสอบถามที่จ่ายเงินในประเทศไทย, เว็บไซต์รางวัล และเกมได้เงินจริง'
          description = 'ทำเงินออนไลน์ด้วยการเข้าร่วมแบบสอบถามที่ได้ค่าตอบแทนสูงในประเทศไทย ใช้ประโยชน์จากเว็บไซต์รางวัลชั้นนำ และเล่นเกมที่ให้เงินจริง ถอนรายได้ของคุณอย่างรวดเร็วผ่านบัตรหรือบัญชีธนาคารของคุณ การหาเงินออนไลน์ในประเทศไทยไม่เคยง่ายอย่างนี้มาก่อน!'
          break
        case 'ES':
          title = 'Gana dinero en línea: Encuestas pagadas, sitios de recompensas y juegos con dinero real'
          description = 'Obtén dinero real por Internet: participa en encuestas bien remuneradas en España, aprovecha los mejores sitios de recompensas y juega a juegos que te pagan dinero de verdad. Con aplicaciones prácticas podrás retirar tus ganancias de forma rápida a tu tarjeta o cuenta bancaria.'
          break
        case 'FR':
          title = 'Gagner de l’argent en ligne : Sondages rémunérés, sites de récompenses et jeux à gains réels'
          description = 'Obtenez de l’argent réel sur Internet : participez à des sondages à haute rémunération, profitez des meilleurs sites de récompenses et jouez à des jeux qui rapportent vraiment. Grâce à des applications pratiques, transférez vos gains rapidement sur votre carte ou votre compte.'
          break
        case 'AT':
          title = 'Online-Einkommen: Bezahlte Umfragen in Österreich, Belohnungsseiten und Geldspiele'
          description = 'Verdienen Sie echtes Geld im Internet: Nehmen Sie an hochbezahlten Umfragen in Österreich teil, nutzen Sie die besten Belohnungsseiten und spielen Sie lukrative Geldspiele. Dank praktischer Apps können Sie Ihre Auszahlungen schnell und sicher auf Ihre Karte oder Ihr Konto erhalten. Online-Geld verdienen in Österreich war noch nie so einfach!'
          break
        case 'BE':
          title = 'Gagner de l’argent en ligne : Sondages rémunérés en Belgique, sites de récompenses et jeux à gains réels'
          description = 'Obtenez de l’argent réel sur Internet : participez à des sondages à haute rémunération en Belgique, profitez des meilleurs sites de récompenses et jouez à des jeux qui paient vraiment. Grâce à des applications pratiques, transférez vos gains rapidement sur votre carte ou votre compte.'
          break
        case 'BR':
          title = 'Ganhe Dinheiro Online: Pesquisas Pagas, Sites de Recompensas e Jogos com Prêmios em Dinheiro'
          description = 'Obtenha dinheiro de verdade pela internet: participe de pesquisas bem remuneradas no Brasil, aproveite os melhores sites de recompensas e jogue jogos que realmente pagam. Com aplicativos práticos, você pode sacar seus ganhos rapidamente no seu cartão ou conta bancária'
          break
        case 'CA':
          title = 'Earn Money Online: Paid Surveys in Canada, Reward Sites, and Real Cash Games'
          description = 'Earn real money online: Participate in high-paying surveys in Canada, take advantage of top reward sites, and play games that pay actual cash. With user-friendly apps, you can quickly withdraw your earnings to your card or bank account.'
          break
        case 'CL':
          title = 'Gana Dinero en Línea: Encuestas Pagadas en Chile, Sitios de Recompensas y Juegos con Dinero Real'
          description = 'Obtén dinero real por Internet: participa en encuestas bien remuneradas en Chile, aprovecha los mejores sitios de recompensas y juega a juegos que realmente pagan. Con aplicaciones prácticas, podrás retirar tus ganancias rápidamente a tu tarjeta o cuenta bancaria.'
          break
        case 'JP':
          title = 'オンラインでお金を稼ぐ：日本で高報酬アンケート、報酬サイト、リアルマネーゲーム'
          description = 'インターネットで本物のお金を手に入れましょう！日本で高額報酬のアンケートに参加し、優れた報酬サイトを活用して、実際にお金が稼げるゲームをプレイしましょう。便利なアプリを使って、報酬を素早くカードや口座へ出金可能。'
          break
        case 'KR':
          title = '온라인으로 돈 벌기: 한국의 유료 설문조사, 리워드 사이트, 그리고 실제 현금 게임'
          description = '인터넷으로 진짜 돈을 벌어보세요! 한국에서 높은 보수를 주는 유료 설문조사에 참여하고, 최고의 리워드 사이트를 활용하며, 실제 현금을 지급하는 게임을 플레이하세요. 편리한 앱을 통해 쉽게 카드나 계좌로 빠르게 출금할 수 있습니다.'
          break
        case 'MX':
          title = 'Gana Dinero en Línea: Encuestas Pagadas en México, Sitios de Recompensas y Juegos con Dinero Real'
          description = 'Obtén dinero real por Internet: participa en encuestas bien remuneradas en México, aprovecha los mejores sitios de recompensas y juega a juegos que realmente pagan. Con aplicaciones prácticas, puedes retirar tus ganancias rápidamente a tu tarjeta o cuenta bancaria.'
          break
        case 'RO':
          title = 'Câștigă bani online: Sondaje plătite în România, site-uri de recompense și jocuri pe bani reali'
          description = 'Obține bani reali prin internet: Participă la sondaje bine plătite în România, valorifică cele mai bune site-uri de recompense și joacă jocuri care oferă câștiguri reale. Cu ajutorul aplicațiilor utile, poți retrage rapid banii pe cardul sau în contul tău.'
          break
        case 'SG':
          title = 'Earn Money Online: Paid Surveys in Singapore, Reward Sites, and Real Cash Games'
          description = 'Earn real money through the internet: Participate in high-paying surveys in Singapore, take advantage of top reward sites, and play games that pay actual cash. With user-friendly apps, you can quickly withdraw your earnings to your card or bank account.'
          break
        case 'VN':
          title = 'Kiếm tiền trực tuyến: Khảo sát trả phí tại Việt Nam, trang web nhận thưởng và trò chơi đổi tiền thật'
          description = 'Kiếm tiền thật qua Internet: Tham gia các khảo sát có mức trả thưởng cao tại Việt Nam, tận dụng các trang web nhận thưởng hàng đầu và chơi những trò chơi mang lại thu nhập thực sự. Nhờ các ứng dụng tiện lợi, bạn có thể rút tiền nhanh chóng về thẻ hoặc tài khoản của mình.'
          break
        case 'LV':
          title = 'Pelni naudu tiešsaistē: apmaksātas aptaujas Latvijā, atlīdzību vietnes un spēles par īstu naudu'
          description = 'Nopelni reālu naudu internetā: piedalies augsti apmaksātās aptaujās Latvijā, izmanto labākās atlīdzību vietnes un spēlē spēles, kas nodrošina īstu peļņu. Ar ērtām lietotnēm vari ātri un droši pārskaitīt savus ienākumus uz karti vai bankas kontu.'
          break
        case 'LT':
          title = 'Užsidirbkite pinigų internete: mokamos apklausos Lietuvoje, atlygį suteikiančios svetainės ir žaidimai už tikrus pinigus'
          description = 'Gaukite realių pajamų internetu: dalyvaukite gerai apmokamose apklausose Lietuvoje, pasinaudokite geriausiomis atlygį siūlančiomis svetainėmis bei žaiskite žaidimus, kurie išmoka tikrus pinigus. Naudodamiesi patogiomis programėlėmis, greitai ir saugiai perveskite uždarbį į savo kortelę ar banko sąskaitą.'
          break
        case 'IT':
          title = 'Guadagna denaro online: Sondaggi retribuiti in Italia, siti di ricompense e giochi con denaro reale'
          description = 'Ottieni denaro reale su Internet: partecipa a sondaggi ben retribuiti in Italia, sfrutta i migliori siti di ricompense e gioca a giochi che pagano davvero. Grazie ad app pratiche, puoi prelevare rapidamente i tuoi guadagni sulla tua carta o sul tuo conto bancario.'
          break
        case 'ID':
          title = 'Hasilkan Uang Secara Online: Survei Berbayar di Indonesia, Situs Reward, dan Permainan Uang Asli'
          description = 'Dapatkan uang nyata melalui internet: Ikuti survei dengan bayaran tinggi di Indonesia, manfaatkan situs reward terbaik, dan mainkan game yang benar-benar membayar. Dengan aplikasi yang mudah digunakan, Anda dapat menarik penghasilan dengan cepat ke kartu atau rekening bank Anda.'
          break
        case 'AU':
          title = 'Earn Money Online: Paid Surveys in Australia, Reward Sites, and Real Cash Games'
          description = 'Earn real money online: Participate in high-paying surveys in Australia, take advantage of top reward sites, and play games that pay actual cash. With user-friendly apps, you can quickly withdraw your earnings to your card or bank account.'
          break
        case 'CZ':
          title = 'Vydělávejte online: Placené průzkumy v České republice, stránky s odměnami a hry o skutečné peníze'
          description = 'Získejte opravdové peníze přes internet: Účastněte se dobře placených průzkumů v České republice, využijte nejlepší odměnové stránky a hrajte hry, které skutečně vyplácejí. Díky praktickým aplikacím můžete své výdělky rychle převést na kartu nebo bankovní účet'
          break
        case 'FI':
          title = 'Tienaaminen verkossa: Maksetut kyselyt Suomessa, palkintosivustot ja oikean rahan pelit'
          description = 'Ansaitse oikeaa rahaa internetin kautta: Osallistu hyvin palkattuihin kyselyihin Suomessa, hyödynnä parhaat palkintosivustot ja pelaa pelejä, jotka maksavat oikeasti. Kätevien sovellusten avulla voit nostaa tulosi nopeasti kortillesi tai tilillesi.'
          break
        case 'EE':
          title = 'Teeni internetis raha: tasulised küsitlused Eestis, preemiasaidid ja pärisraha mängud'
          description = 'Teeni pärisraha interneti kaudu: osale kõrgelt tasustatud küsitlustes Eestis, kasuta parimaid preemiasaite ja mängi mänge, mis maksavad tõeliselt. Tänu mugavatele rakendustele saad oma teenistuse kiiresti kaardile või pangakontole kanda.'
          break
        case 'NL':
          title = 'Online geld verdienen: Betaalde enquêtes in Nederland, beloningssites en spellen om echt geld'
          description = 'Verdien echt geld via internet: Neem deel aan goed betaalde enquêtes in Nederland, maak gebruik van de beste beloningssites en speel spellen die daadwerkelijk uitbetalen. Met handige apps kun je je verdiensten snel naar je kaart of bankrekening overmaken.'
          break
        case 'SE':
          title = 'Tjäna pengar online: Betalda undersökningar i Sverige, belöningssidor och spel med riktiga pengar'
          description = 'Tjäna riktiga pengar via internet: Delta i välbetalda undersökningar i Sverige, utnyttja de bästa belöningssidorna och spela spel som faktiskt betalar ut. Med användarvänliga appar kan du snabbt föra över dina intäkter till ditt kort eller bankkonto.'
          break
        default:
          title = 'Earn Cash Online: Surveys, Reward Sites, and Cash Apps'
          description = 'Make real money by taking online High-Paying surveys on the best sites. Use apps to earn free cash and play games that pay real money. Withdraw instantly to your card.'
      }

      return createMeta.call(this, {
        title,
        description,
        sharingDescription: description
      })
    }
    return createMeta.call(this, {
      title: this.$t('missionsHeadTitle'),
      description: this.$t('missionsHeadDescription'),
      sharingDescription: this.$t('missionsHeadDescription')
    })
  },

  jsonld () {
    return {
      '@type': 'CreativeWorkSeries',
      name: this.$t('quests'),
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingCount: 25,
        ratingValue: 5,
        bestRating: 5,
        worstRating: 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.offers-page {
  padding: 10px;

  @media (min-width: $breakpointTablet) {
    padding: 60px;
  }

  &__h1 {
    margin: 18px 0 20px;
    font-weight: 500;
    font-size: 40px;
    line-height: 40px;
    color: $white;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;

    @media (min-width: $breakpointTablet) {
      flex-direction: row;
    }

    &-text {
      font-weight: 500;
      font-size: 20px;
      line-height: 28px;
      color: $blue-grey05;

      &-container {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        width: 100%;

        @media (min-width: $breakpointTablet) {
          flex-direction: row;
          width: max-content;
          align-items: center;
          justify-content: flex-start;
        }
      }
    }

    &-create-offer {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 8px;
      background-color: $green60;
      border-radius: 8px;
      height: 48px;
      min-width: 270px;
      width: 100%;
      color: $white;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      cursor: pointer;
      text-decoration: none;

      @media (min-width: $breakpointTablet) {
        width: auto;
        margin: 0 16px;
      }
    }

    &-telegram-button {
      width: 100%;
      margin-top: 8px;

      @media (min-width: $breakpointTablet) {
        width: 120px;
        margin-top: 0;
      }
    }
  }

  &__slider {
    @include silent-scroll;

    display: grid;
    grid-template-columns: repeat(var(--amount), 290px);
    grid-gap: 8px;
    width: 100%;
    min-width: 160px;
    margin: 20px 0;
    border-radius: 10px;
    overflow-x: auto;
    //padding-bottom: 10px;

    @media (min-width: $breakpointDesktopWide) {
      grid-template-columns: repeat(4, 1fr);
      grid-gap: 16px;
    }

    &--violet {
      border-radius: 10px;
      margin: 30px 0;
      padding: 20px 16px;
      background: linear-gradient(262deg, #3949AB 5.62%, #5C6BC0 95.25%);
    }
  }

  &__filters-top {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 17px;

    &-title {
      font-weight: 500;
      font-size: 26px;
      line-height: 40px;
      margin: 0 0 24px;
      color: $white;

      &-container {
        @media (min-width: $breakpointTablet) {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }

      &-button {
        margin: 0 0 20px auto;
        background: transparent !important;
        border: 2px solid $white;
      }
    }

    &-with-search {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 16px;
      align-items: center;

      @media (min-width: $breakpointDesktopWide) {
        display: flex;
        justify-content: space-between;
      }
    }

    &-search {
      @media (min-width: $breakpointDesktopWide) {
        max-width: 300px;
      }
    }

    &-block {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr max-content;
      grid-gap: 10px;
      margin-top: 12px;
      margin-bottom: 12px;
      align-items: center;

      &-element {
        display: grid;
        grid-template-columns: max-content max-content;
        grid-gap: 10px;
        align-items: center;

        &-label {
          font-weight: 400;
          font-size: 14px;
          line-height: 28px;
          color: $fc-grey-2;
        }

        &-input {
          padding: 7px 24px;
          background-color: $blue-grey70;
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          color: $fc-grey-2;
          border-radius: 10px;
          border: 1px solid $blue-grey50;
        }
      }
    }
  }

  &__offers {
    padding-top: 20px;

    &-list {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 10px;

      @media (min-width: $breakpointTablet) {
        grid-template-columns: 1fr 1fr;
      }

      @media (min-width: $breakpointDesktop) {
        grid-template-columns: 1fr 1fr 1fr;
      }

      @media (min-width: $breakpointDesktopWide) {
        grid-template-columns: 1fr 1fr 1fr 1fr;
      }
    }

    &-offer {
      --img-size: 80px;
      display: grid;
      grid-template-columns: var(--img-size) 1fr;
      grid-gap: 10px 20px;
      width: 100%;
      padding: 20px;
      background-color: $blue-grey70;
      border: 1px solid $blue-grey50;
      border-radius: 10px;
      overflow: hidden;

      &-img {
        width: var(--img-size);
        height: var(--img-size);
        border-radius: 10px;
        object-fit: contain;
      }

      &-body {
        display: flex;
        flex-direction: column;

        &-name {
          font-weight: 700;
          font-size: 16px;
          line-height: 16px;
          color: $white;
        }

        &-category {
          &-label {
            margin-top: 12px;
            font-weight: 500;
            font-size: 12px;
            line-height: 28px;
            color: $fc-grey-2;
          }

          &-name {
            width: 100%;
            padding: 1px 0;
            font-weight: 500;
            font-size: 14px;
            line-height: 28px;
            text-align: center;
            background-color: $blue-grey80;
            border: 1px solid $blue-grey50;
            border-radius: 10px;
            color: $white;
          }
        }
      }

      &-payout {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 42px;
        border: 1px solid #E38C25;
        border-radius: 10px;

        &-amount {
          font-weight: 500;
          font-size: 14px;
          line-height: 28px;
          color: $white;
          margin-right: 5px;
        }

        &-currency {
          font-weight: 500;
          font-size: 14px;
          line-height: 28px;
          color: #E38C25;
        }
      }

      &-button {
        width: 100%;
      }
    }
  }

  &__filters-bottom {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 10px;
    align-items: center;

    @media (min-width: $breakpointTablet) {
      grid-template-columns: 1fr 1fr;
    }

    @media (min-width: $breakpointDesktopWide) {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }
  }

  &__offerwalls {
    @include silent-scroll;
    --count: 30;
    display: grid;
    grid-template-columns: repeat(var(--count), 102px);
    grid-gap: 8px;
    align-items: center;
    width: 100%;
    //padding-bottom: 20px;
    margin-top: 10px;
    overflow: auto;

    @media (min-width: $breakpointDesktopWide) {
      grid-template-columns: repeat(var(--count), 148px);
    }

    &-offerwall {
      width: 102px;
      max-height: 48px;
      padding: 12px;
      background-color: $blue-grey70;
      border: 1px solid $blue-grey50;
      border-radius: 10px;
      object-fit: contain;
      cursor: pointer;

      @media (min-width: $breakpointDesktopWide) {
        width: 148px;
        max-height: 56px;
        padding: 12px 16px;
      }

      &-icon {
        width: 100%;
        max-height: 24px;
        object-fit: contain;
      }
    }
  }
}
</style>
